import { render, staticRenderFns } from "./icon-font-panel.vue?vue&type=template&id=5e4f7504&scoped=true&"
import script from "./icon-font-panel.vue?vue&type=script&lang=js&"
export * from "./icon-font-panel.vue?vue&type=script&lang=js&"
import style0 from "./icon-font-panel.vue?vue&type=style&index=0&id=5e4f7504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4f7504",
  null
  
)

export default component.exports